export default [
  {
    name: 'defaultIntelligentFollowUpList',
    path: 'intelligentFollowUpList',
    component: () => import(
      /* webpackChunkName: 'intelligentFollowUpList' */
      '../views/intelligent-follow-up/list/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultIntelligentFollowUpList',
    },
  },
  {
    name: 'defaultIntelligentFollowUpSetting',
    path: 'intelligentFollowUpSetting',
    component: () => import(
      /* webpackChunkName: 'intelligentFollowUpSetting' */
      '../views/intelligent-follow-up/detail/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultIntelligentFollowUpList',
    },
  },
  {
    name: 'defaultIntelligentFollowUpDetail',
    path: 'intelligentFollowUpDetail',
    component: () => import(
      /* webpackChunkName: 'intelligentFollowUpDetail' */
      '../views/intelligent-follow-up/patientDetails/index.vue'),
    meta: {
      tabGroup: 'defaultIntelligentFollowUpList',
    },
  },
  {
    name: 'defaultIntelligentFollowUpNewForm',
    path: 'intelligentFollowUpNewForm',
    component: () => import(
      /* webpackChunkName: 'intelligentFollowUpNewForm' */
      '../views/intelligent-follow-up/newForm/index.vue'),
  },
  {
    name: 'defaultIntelligentFollowUpNewSpecialDiseaseLibrary',
    path: 'intelligentFollowUpNewSpecialDiseaseLibrary',
    component: () => import(
      /* webpackChunkName: 'intelligentFollowUpNewSpecialDiseaseLibrary' */
      '../views/intelligent-follow-up/newSpecialDiseaseLibrary/index.vue'),
  },

  {
    name: 'defaultDiagnosisPlan',
    path: 'afterDiagnosisPlan',
    component: () => import(/* webpackChunkName: 'defaultDiagnosisPlan' */ '../views/afterDiagnosisPlan/list/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultDiagnosisPlan', // 在菜单栏属于诊后业务
    },
  },
  {
    name: 'defaultAfterDiagnosisPlanSetting',
    path: 'afterDiagnosisPlanSetting',
    component: () => import(
      /* webpackChunkName: 'defaultAfterDiagnosisPlan' */
      '../views/afterDiagnosisPlan/detail/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultDiagnosisPlan', // 在菜单栏属于诊后业务
    },
  },
  {
    name: 'defaultAfterDiagnosisPlanDetail',
    path: 'afterDiagnosisPlanDetail',
    component: () => import(
      /* webpackChunkName: 'defaultAfterDiagnosisPlanDetail' */
      '../views/afterDiagnosisPlan/patientDetails/index.vue'),
    meta: {
      tabGroup: 'defaultDiagnosisPlan', // 在菜单栏属于诊后业务
    },
  },
  {
    name: 'defaultAfterDiagnosisTeachingConfig',
    path: 'afterDiagnosisTeachingConfig',
    component: () => import(
      /* webpackChunkName: 'defaultAfterDiagnosisTeachingConfig' */
      '../views/afterDiagnosisPlan/detail/teachingConfig.vue'),
    meta: {
      tabGroup: 'defaultDiagnosisPlan', // 在菜单栏属于诊后业务
    },
  },
  {
    name: 'defaultToolsForDoctor',
    path: 'toolsForm',
    component: () => import(/* webpackChunkName: 'defaultToolsForDoctor' */ '../views/toolsForDoctor/list/index.vue'),
    meta: {
      keepAlive: true,
      tabGroup: 'defaultToolsForDoctor', // 智能表单
    },
  },
  {
    name: 'defaultToolsSetting',
    path: 'toolsForm/:subpath',
    component: () => import(
      /* webpackChunkName: 'defaultToolsSetting' */
      '../views/toolsForDoctor/detail/index.vue'),
    meta: {
      tabGroup: 'defaultToolsForDoctor', // 智能表单
    },
  },
  {
    name: 'defaultToolsPatientDetails',
    path: 'patientdetails',
    component: () => import(
      /* webpackChunkName: 'defaultToolsPatientDetails' */
      '../views/toolsForDoctor/patientDetails/index.vue'),
  },
  {
    name: 'defaultTemplateManage',
    path: 'templateManage',
    component: () => import(
      /* webpackChunkName: 'defaultTemplateManage' */
      '@/views/templateManage/index.vue'), // 模版管理
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'defaultThirdPartyMappingList',
    path: 'thirdPartyMappingList',
    component: () => import(
      /* webpackChunkName: 'defaultThirdPartyMappingList' */
      '../views/third-party/followup-mapping/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: 'planFill',
    name: 'planFill',
    component: () => import(/* webpackChunkName: 'planFIll' */ '../views/plan/fill.vue'),
  },
];
